// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"741":"9c872bcb","824":"355cf3c4","845":"43df4d5c"}[chunkId] + ".chunk.css";
};